import { render, staticRenderFns } from "./itemMedicament.vue?vue&type=template&id=5772a48f&"
import script from "./itemMedicament.vue?vue&type=script&lang=js&"
export * from "./itemMedicament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports